class IgEngraving extends HTMLElement {
  static valuesByProduct = new Map();

  #abortController = new AbortController();

  connectedCallback() {
    if (this.#abortController.signal.aborted) {
      this.#abortController = new AbortController();
    }

    const input = this.querySelector('[data-engraving-input]');
    const form = document.getElementById(this.dataset.formId || '');

    if (!(input instanceof HTMLInputElement)) return;

    const { signal } = this.#abortController;
    const savedValue = IgEngraving.valuesByProduct.get(this.dataset.productKey || '');
    if (savedValue && !input.value) input.value = savedValue;

    input.addEventListener('input', this.#handleInput, { signal });
    input.addEventListener('blur', this.#trimValue, { signal });
    form?.addEventListener('formdata', this.#handleFormData, { signal });
    this.#updateDisplay();
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  #getInput = () => {
    const input = this.querySelector('[data-engraving-input]');
    return input instanceof HTMLInputElement ? input : null;
  };

  #normalizeValue = () => {
    const input = this.#getInput();
    if (!input) return '';

    const normalized = input.value.trim().slice(0, 15);
    input.value = normalized;
    this.#rememberValue(normalized);
    this.#updateDisplay();
    return normalized;
  };

  #trimValue = () => {
    this.#normalizeValue();
  };

  #handleInput = () => {
    const input = this.#getInput();
    if (!input) return;

    this.#rememberValue(input.value);
    this.#updateDisplay();
  };

  #rememberValue = (value) => {
    const productKey = this.dataset.productKey || '';
    if (!productKey) return;

    if (value) {
      IgEngraving.valuesByProduct.set(productKey, value);
    } else {
      IgEngraving.valuesByProduct.delete(productKey);
    }
  };

  #updateDisplay = () => {
    this.#updateRemaining();
    this.#updatePreview();
  };

  #updateRemaining = () => {
    const input = this.#getInput();
    const remaining = this.querySelector('[data-engraving-remaining]');
    if (!input || !(remaining instanceof HTMLElement)) return;

    const count = Math.max(0, 15 - input.value.length);
    remaining.textContent = `${count} ${count === 1 ? 'character' : 'characters'} remaining`;
  };

  #updatePreview = () => {
    const input = this.#getInput();
    const preview = this.querySelector('[data-engraving-preview]');
    const previewValue = this.querySelector('[data-engraving-preview-value]');
    if (!input || !(preview instanceof HTMLElement) || !(previewValue instanceof HTMLElement)) return;

    previewValue.textContent = input.value;
    preview.hidden = input.value.length === 0;
  };

  #handleFormData = (event) => {
    if (!('formData' in event) || !(event.formData instanceof FormData)) return;

    const propertyName = this.dataset.propertyName;
    if (!propertyName) return;

    const value = this.#normalizeValue();
    if (value) {
      event.formData.set(propertyName, value);
    } else {
      event.formData.delete(propertyName);
    }
  };
}

if (!customElements.get('ig-engraving')) {
  customElements.define('ig-engraving', IgEngraving);
}
